import updateColors from './updateColors';
import clearColors from './clearColors';

import combineActions from '../../utils/combineActions';

export default combineActions({
    updateColors,
    clearColors,
});
